(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-treeselect", [], factory);
	else if(typeof exports === 'object')
		exports["vue-treeselect"] = factory();
	else
		root["vue-treeselect"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition